import React, { FunctionComponent } from "react";
import { useIntl } from "react-intl";
import { AssetHighlight, PartnershipHighlight, ProductHighlight } from "@Types/header";
import { setDataLayerTrack } from "@Utils/track";
import "./style.scss";

export interface Props {
  highlight: ProductHighlight | PartnershipHighlight | AssetHighlight;
}

const HeaderHighlight: FunctionComponent<Props> = ({ highlight }) => {
  const intl = useIntl();
  const localeSlug = intl.locale;

  const isLinkedHighlight = (
    headerHighlight: ProductHighlight | PartnershipHighlight | AssetHighlight
  ): headerHighlight is ProductHighlight | PartnershipHighlight => {
    return "url" in headerHighlight;
  };

  return (
    <div
      className="HeaderHighlight"
      onClick={() =>
        setDataLayerTrack("Product List Clicked", {
          categoryPageTag: highlight.tag,
          linkPosition: "Menu",
        })
      }
    >
      {isLinkedHighlight(highlight) ? (
        <a className="HeaderHighlight-image-wrapper" href={`/${localeSlug}${highlight.url}`}>
          <img
            alt={highlight.title}
            className="HeaderHighlight-image"
            src={highlight.images["1x"]}
            srcSet={`${highlight.images["1x"]} 1x, ${highlight.images["2x"]} 2x`}
          />
        </a>
      ) : (
        <div className="HeaderHighlight-image-wrapper">
          <img
            alt={highlight.tag}
            className="HeaderHighlight-image"
            src={highlight.images["1x"]}
            srcSet={`${highlight.images["1x"]} 1x, ${highlight.images["2x"]} 2x`}
          />
        </div>
      )}
      {isLinkedHighlight(highlight) ? (
        <a className="HeaderHighlight-label" href={`/${localeSlug}${highlight.url}`}>
          {highlight.title}
        </a>
      ) : (
        <div className="HeaderHighlight-label">{highlight.title}</div>
      )}
      {isLinkedHighlight(highlight) ? (
        <a
          className="HeaderHighlight-sublabel"
          dangerouslySetInnerHTML={{ __html: highlight.subTitle }}
          href={`/${localeSlug}${highlight.url}`}
        />
      ) : (
        <div
          className="HeaderHighlight-sublabel"
          dangerouslySetInnerHTML={{ __html: highlight.subTitle }}
        />
      )}
    </div>
  );
};

export default HeaderHighlight;
